$(document).ready(function () {


$(".swatch-element.color").each(function(){
$(this).on("click", function(){
   setTimeout(function() {

const url = window.location.href;
const indexOfEqualSign = url.indexOf("=");

if (indexOfEqualSign !== -1) {
    
  const valueAfterEqual = url.slice(indexOfEqualSign + 1);
if(valueAfterEqual==43078018793633){
  
    setTimeout(function() {
$("[data-option='option2'] option:last-child").attr("disabled","true");
        }, 500);
    }
    else{
console.log('1');
        
    }
}
 else {
console.log('1');
    
}
}, 1000);
});
});



  
 // $('.single-option-selector[data-option="option2"]').on('change', function(){
$(document).on('change', '.single-option-selector[data-option="option2"]', function(){
  
setTimeout(function() {
    $('.single-option-selector[data-option="option3"] option').each(function(){
    
         if($(this).attr("disabled") === undefined ){
console.log($(this).text());
            $(this).prop('selected', true);
              $('.single-option-selector[data-option="option3"]').change();
             return false;
        }
    })
     }, 1000);
});
  $(".cstm-portfolio-slider").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows:false
  });
  
 function checkAvail() {
  	var currentPageUrl = document.URL;
  	var url = new URL(currentPageUrl);
  	var isVariantUrl = url.searchParams.get("variant");
                
  currentPageUrl = isVariantUrl ? currentPageUrl : isVariantUrl;
   if(currentPageUrl && firstTimeUrl != currentPageUrl) {
       firstTimeUrl = currentPageUrl;
      updateSampleButton(isVariantUrl);
    }
 }     

  // setTimeout(function () {
  //   $('.product .swatch_options input:nth(0)').trigger('change');
  //   checkAvail();
  // },1000);
  setTimeout(function () {
    var asd = $("#product_variant_purchase_unit").text();
    var cstm_sf_text2 = $(".cstm-uom-dom-content").text();

    // if (cstm_sf_text2.includes("SF")) {
    //   $(
    //     ".cstm-product-details-type-item-code #product_variant_purchase_unit .cstm-uom-dom-content"
    //   ).text("sq ft.");
    // }
    if (asd.includes("CARTON") || asd.includes("PALLET")) {
      $(".both-buttons").addClass("showcalculator");
      $("#cartonCalculator").css("display", "block");
    } else {
      $(".both-buttons").removeClass("showcalculator");
      $("#cartonCalculator").css("display", "none");
      $(".purchase-details__quantity.product-quantity-box label span").text(
        "Quantity to Purchase"
      );
    }
    $(".single-option-selector").on("change", function () {
      setTimeout(function () {
        var asd = $("#product_variant_purchase_unit").text();
        var cstm_sf_text = $(".cstm-uom-dom-content").text();
        var url_page = window.location.href;
        if (asd.includes("CARTON") || asd.includes("PALLET")) {
          setTimeout(function () {
          $(".both-buttons").addClass("showcalculator");
          $("#cartonCalculator").css("display", "block");
          }, 101);
        } else {
          $(".both-buttons").removeClass("showcalculator");
          $("#cartonCalculator").css("display", "none");
        }
        if (url_page.includes("admire")) {
          if (cstm_sf_text.includes("SF")) {
            $(
              ".cstm-product-details-type-item-code #product_variant_purchase_unit .cstm-uom-dom-content"
            ).text("sq ft.");
          }
        } else if (cstm_sf_text.includes("SF")) {
          $(
            ".cstm-product-details-type-item-code #product_variant_purchase_unit .cstm-uom-dom-content"
          ).text("sq ft.");
        } else {
          $(".both-buttons").removeClass("showcalculator");

          $("#cartonCalculator").css("display", "none");
          $(".purchase-details__quantity.product-quantity-box label span").text(
            "Quantity to Purchase"
          );
        }
      }, 1500);
    });
  }, 2500);

  if ($("body").hasClass("product")) {
    $(document).ready(function () {
      $(
        ".product.clearfix .product_section .product_form.is-visible .shopify-product-form .swatch_options .swatch.clearfix .v-swatch.cstm-swatch-item"
      )
        .eq(1)
        .trigger("click");
    });
  }

  if ($("body").hasClass("product")) {
    var location = window.location.href;
    if ($("location".includes("?variant"))) {
      $(document).ready(function () {
        $(
          ".product.clearfix .product_section .product_form.is-visible .shopify-product-form .swatch_options .swatch.clearfix .v-swatch.cstm-swatch-item"
        )
          .eq(0)
          .trigger("click");
      });
    } else {
      $(document).ready(function () {
        $(
          ".product.clearfix .product_section .product_form.is-visible .shopify-product-form .swatch_options .swatch.clearfix .v-swatch.cstm-swatch-item"
        )
          .eq(1)
          .trigger("click");
      });
    }
  }

  var url = window.location.href;
  var mission = "https://architessa.com/pages/about-us#mission-statement";
  var story = "https://architessa.com/pages/about-us#giving-back";
  var core = "https://architessa.com/pages/about-us#core-values";
  var team = "https://architessa.com/pages/about-us#our-team";
  if (url == mission) {
    console.log("mission");
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: $("#mission-statement").offset().top - 56,
        },
        400
      );
    }, 600);
  } else if (url == story) {
    console.log("story");
    $("html, body").animate(
      {
        scrollTop: $("#giving-back").offset().top - 65,
      },
      400
    );
  } else if (url == core) {
    console.log("core");
    $("html, body").animate(
      {
        scrollTop: $("#core-values").offset().top - 56,
      },
      400
    );
  } else if (url == team) {
    console.log("team");
    $("html, body").animate(
      {
        scrollTop: $("#our-team").offset().top - 56,
      },
      400
    );
  } else {
    console.log("error");
  }

  $(
    "body.page-details-about-us .footer .toggle_content ul li p a.mission-statement"
  ).click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#mission-statement").offset().top - 56,
      },
      400
    );
  });
  $(
    "body.page-details-about-us .footer .toggle_content ul li p a.giving-back"
  ).click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#giving-back").offset().top - 65,
      },
      400
    );
  });
  $(
    "body.page-details-about-us .footer .toggle_content ul li p a.core-values"
  ).click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#core-values").offset().top - 56,
      },
      400
    );
  });
  $(
    "body.page-details-about-us .footer .toggle_content ul li p a.our-team"
  ).click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#our-team").offset().top - 56,
      },
      400
    );
  });

  $("#product-details.custom-accordion").addClass("active");
  $("#accordian-content-1.custom-accordion-content").css("display", "block");

  //   $('#specifications.custom-accordion').addClass("active");
  // $('#accordian-content-2.custom-accordion-content').css("display","block");
  $(".testimonials-content-slider-content").slick({
    infinite: true,
    speed: 1000,
    arrows: true,
    prevArrow:
      '<img src="https://cdn.shopify.com/s/files/1/0416/7847/1329/files/left-arrow.png?v=1674032669" class="cstm-testimonial previous">',
    nextArrow:
      '<img src="https://cdn.shopify.com/s/files/1/0416/7847/1329/files/right-arrow.png?v=1674032669" class="cstm-testimonial next">',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
  });
  $(".cstm-testimonial-content-slider").wrapAll(
    "<div class='cstm-list-wrapper-testimonial-slider' />"
  );

  // jQuery Plugin: http://flaviusmatis.github.io/simplePagination.js/

  (function ($) {
    var paginate = {
      startPos: function (pageNumber, perPage) {
        // determine what array position to start from
        // based on current page and # per page
        return pageNumber * perPage;
      },

      getPage: function (items, startPos, perPage) {
        // declare an empty array to hold our page items
        var page = [];

        // only get items after the starting position
        items = items.slice(startPos, items.length);

        // loop remaining items until max per page
        for (var i = 0; i < perPage; i++) {
          page.push(items[i]);
        }

        return page;
      },

      totalPages: function (items, perPage) {
        // determine total number of pages
        return Math.ceil(items.length / perPage);
      },

      createBtns: function (totalPages, currentPage) {
        // create buttons to manipulate current page
        var pagination = $('<div class="pagination" />');

        // add a "first" button
        pagination.append('<span class="pagination-button prev">< Prev</span>');

        // add pages inbetween
        for (var i = 1; i <= totalPages; i++) {
          // truncate list when too large
          if (totalPages > 5 && currentPage !== i) {
            // if on first two pages
            if (currentPage === 1 || currentPage === 2) {
              // show first 5 pages
              if (i > 5) continue;
              // if on last two pages
            } else if (
              currentPage === totalPages ||
              currentPage === totalPages - 1
            ) {
              // show last 5 pages
              if (i < totalPages - 4) continue;
              // otherwise show 5 pages w/ current in middle
            } else {
              if (i < currentPage - 2 || i > currentPage + 2) {
                continue;
              }
            }
          }

          // markup for page button
          var pageBtn = $('<span class="pagination-button page-num" />');

          // add active class for current page
          if (i == currentPage) {
            pageBtn.addClass("active");
          }

          // set text to the page number
          pageBtn.text(i);

          // add button to the container
          pagination.append(pageBtn);
        }

        // add a "last" button
        pagination.append(
          $('<span class="pagination-button next">Next ></span>')
        );

        return pagination;
      },

      createPage: function (items, currentPage, perPage) {
        // remove pagination from the page
        $(".pagination").remove();

        // set context for the items
        var container = items.parent(),
          // detach items from the page and cast as array
          items = items.detach().toArray(),
          // get start position and select items for page
          startPos = this.startPos(currentPage - 1, perPage),
          page = this.getPage(items, startPos, perPage);

        // loop items and readd to page
        $.each(page, function () {
          // prevent empty items that return as Window
          if (this.window === undefined) {
            container.append($(this));
          }
        });

        // prep pagination buttons and add to page
        var totalPages = this.totalPages(items, perPage),
          pageButtons = this.createBtns(totalPages, currentPage);

        container.after(pageButtons);
      },
    };

    // stuff it all into a jQuery method!
    $.fn.paginate = function (perPage) {
      var items = $(this);

      // default perPage to 5
      if (isNaN(perPage) || perPage === undefined) {
        perPage = 5;
      }

      // don't fire if fewer items than perPage
      if (items.length <= perPage) {
        return true;
      }

      // ensure items stay in the same DOM position
      if (items.length !== items.parent()[0].children.length) {
        items.wrapAll('<div class="pagination-items" />');
      }

      // paginate the items starting at page 1
      paginate.createPage(items, 1, perPage);

      // handle click events on the buttons
      $(document).on("click", ".pagination-button", function (e) {
        // get current page from active button
        var currentPage = parseInt($(".pagination-button.active").text(), 10),
          newPage = currentPage,
          totalPages = paginate.totalPages(items, perPage),
          target = $(e.target);

        // get numbered page
        newPage = parseInt(target.text(), 10);
        if (target.text() == "< Prev") newPage = 1;
        if (target.text() == "Next >") newPage = totalPages;

        // ensure newPage is in available range
        if (newPage > 0 && newPage <= totalPages) {
          paginate.createPage(items, newPage, perPage);
        }

        $(".testimonials-content-slider").each(function () {
          $(".testimonials-content-slider-below-text-para a.morelink").click(
            function () {
              $(this).parent().parent().addClass("non-active");
              $(this).parent().parent().next().addClass("active");
            }
          );
          $(".testimonials-content-slider-below-text-para a.lesslink").click(
            function () {
              $(this).parent().parent().prev().removeClass("non-active");
              $(this).parent().parent().removeClass("active");
            }
          );
        });
      });
    };
  })(jQuery);

  /* This part is just for the demo,
not actually part of the plugin */
  $(".testimonials-content-slider").paginate(3);


  jQuery(".pagination-button.prev").hide();
  $(document).on("click", ".pagination-button.page-num", function () {
    if (jQuery(this).prev().hasClass("prev")) {
      jQuery(".prev").hide();
      jQuery(".next").show();
    } else if (jQuery(this).next().hasClass("next")) {
      jQuery(".prev").show();
      jQuery(".next").hide();
    } else {
      jQuery(".prev").show();
      jQuery(".next").show();
    }
  });

  $(document).on("click", ".pagination-button.next", function () {
    jQuery(".pagination-button.prev").show();
    setTimeout(function () {
      if (jQuery(".pagination-button.next").prev().hasClass("active")) {
        jQuery(".pagination-button.next").hide();
      }
    }, 500);
  });

  $(document).on("click", ".pagination-button.prev", function () {
    jQuery(".pagination-button.next").show();
    setTimeout(function () {
      if (jQuery(".pagination-button.prev").next().hasClass("active")) {
        jQuery(".pagination-button.prev").hide();
      }
    }, 500);
  });

  $(document).on("click", ".swatch-element label", function () {
    var data_id = jQuery(this).parents(".swatch-element").attr("data-id");
    console.log(data_id);

    jQuery(".multi_select option").each(function () {
      var value_opt = jQuery(this).attr("value");

      if (value_opt == data_id) {
        var val_txt = jQuery(this).text();
        var sku_txt = jQuery(this).attr("data-sku");
        var prod_title = jQuery(
          ".section.product_section .title-and-wishlist h1.product_name"
        ).text();
        setTimeout(function () {
          // alert();
          jQuery("#request-sample-form input[title=Comments]").attr(
            "value",
            "I would like to request a sample of " +
              prod_title +
              " - " +
              val_txt +
              " SKU: " +
              sku_txt
          );
        }, 2500);
      }
    });
  });
  var product_name = $('.product_name').text();
  setTimeout(function () {
  if(product_name == 'Tangier'){
  $('.shopify-section.product-template .sixteen.columns.product__container .seven.columns .shopify-product-form .swatch_options .swatch.color input:nth-child(4)').trigger('click');
    $('.shopify-section.product-template .sixteen.columns.product__container .seven.columns .shopify-product-form .swatch_options .swatch.color input:nth-child(2)').trigger('click');
    }
    }, 2000);
});


$(document).on("click", ".swatch-element.color", function () {
  setTimeout(function () {
    var count = 0;
    jQuery(".single-option-selector:last option").each(function () {
      console.log(jQuery(this).html());

      var disabled_val = jQuery(this).attr("disabled");
      console.log(disabled_val);
      if (disabled_val != "disabled") {
        count++;
        if (count == 1) {
          var valueopt = jQuery(this).val();
          // console.log('valueopt',valueopt);
          $(".single-option-selector:last").val(valueopt).change();
        }
      }
    });
  }, 1000);
});
